import { PageTemplate } from "@/components/Templates/PageTemplate";
import type { ExtraTab } from "@/components/Templates/types";
import EnrollmentMetricsTab from "./EnrollmentMetricsTab";
import PlannedEnrolmentTab from "./PlannedEnrolmentTab";

const extraTabs: ExtraTab[] = [
  {
    type: "custom",
    key: "expectation-vs-actual",
    title: "Expectation vs Actual",
    component: EnrollmentMetricsTab,
    toolbar: {
      showOnly: ["workspace", "guide"],
    },
  },
  {
    type: "custom",
    key: "planned-enrolment",
    title: "Planned",
    component: PlannedEnrolmentTab,
    toolbar: {
      showOnly: ["guide"],
    },
  },
];

export default function TrialEnrollment() {
  return (
    <PageTemplate
      title="Enrollment"
      tooltipText="Explore enrollment across any level - from a single site, to sites in a country or region, to all of the sites in the study. View enrollment rates, trends, and forecasts against your study's enrollment targets."
      type="trial-enrollment"
      constants={{
        wikiLink: "/wiki/guides/exploration-trial-enrollment",
        idLink: undefined,
      }}
      extraTabs={extraTabs}
    />
  );
}
